// Components==============
import React from 'react';
import { TranslateType } from 'typings';
import Spinner from '../Spinner/Spinner';
import './BuilderCard.module.scss';
// =========================

export default function BuilderCard({
  children,
  title,
  loading = false,
}: {
  children: React.ReactNode;
  title: TranslateType;
  loading?: boolean;
}) {
  return (
    <div styleName="wrapper">
      {title && (
        <div styleName="text">
          <p>{title}</p>
          <Spinner loading={loading} />
        </div>
      )}
      <div styleName="card">{children}</div>
    </div>
  );
}
